import GeoJSON from 'ol/format/GeoJSON.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { OSM, Vector as VectorSource } from 'ol/source.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import Overlay from 'ol/Overlay';
import { fromLonLat, toLonLat } from 'ol/proj';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import { Circle, Fill, Stroke } from 'ol/style.js';
import Extent from 'ol/interaction/Extent.js';
import { KeyboardPan } from 'ol/interaction';
import * as olCoordinate from 'ol/coordinate';
import { containsCoordinate } from 'ol/extent';

const mapElement = document.getElementById('map');

const extent = [ -10350429.62918427, 5520679.372230341, -9062860.347692756, 6137725.353775795 ];

const view = new View({
  center: fromLonLat([-87.19627550636471, 46.304014745648445]),
  zoom: 7.5,
});

const map = new Map({
  layers: [
    new TileLayer({
      source: new OSM(),
    }),
  ],
  target: 'map',
  view: view,
});

// map.on('pointerdrag', function () {
//   let centerPosArr = map.getView().getCenter();
//   let coords = toLonLat(centerPosArr, 'EPSG:3857');
//   console.log(centerPosArr);
//   console.log(coords);
// });

// console.log(fromLonLat([-87.15831003757064, 46.303533225972224]));
// console.log(fromLonLat([-87.35556253862593, 46.49434911405965]));
// console.log("Onota: ", fromLonLat([-86.705833, 46.440833]).toString());
// var extent = map.getView().calculateExtent(map.getSize());
// console.log("Extent in map projection:", extent);

const fill = new Fill({
  color: '#3F71A6',
});

const stroke = new Stroke({
  color: '#3F71A6',
  width: 2,
});

// Create a vector source {Vector as VectorSource}
// This method loads the features asynchronously using XHR feature loader.
const vectorSource = new VectorSource({
  url: "data/towns.geojson",
  format: new GeoJSON(),
});

// Create a vector layer with marker style {Layer as VectorLayer}
const townLayer = new VectorLayer({
  source: vectorSource,
  style: new Style({
    image: new Circle({
      fill: fill,
      stroke: stroke,
      radius: 10,
    }),
  }),
});

// Add the layer to the map
map.addLayer(townLayer);

/* #region Build an info tooltip on hover */
const info = document.getElementById('info');

let currentFeature;
const displayFeatureInfo = function (pixel, target) {
  const feature = target.closest('.ol-control')
    ? undefined
    : map.forEachFeatureAtPixel(pixel, function (feature) {
      return feature;
    });
  if (feature) {
    info.style.left = pixel[0] + 'px';
    info.style.top = pixel[1] + 'px';
    if (feature !== currentFeature) {
      info.style.visibility = 'visible';
      info.innerText = feature.get('name');
    }
  } else {
    info.style.visibility = 'hidden';
  }
  currentFeature = feature;
};

map.on('pointermove', function (evt) {
  if (evt.dragging) {
    info.style.visibility = 'hidden';
    currentFeature = undefined;
    return;
  }
  displayFeatureInfo(evt.pixel, evt.originalEvent.target);
});

map.getTargetElement().addEventListener('pointerleave', function () {
  currentFeature = undefined;
  info.style.visibility = 'hidden';
});
/* #endregion */


// Create Tooltip with Close Button
const tooltip = document.createElement('div');
tooltip.className = 'tooltip';
tooltip.innerHTML = `
  <div id="poi-dialog" aria-modal="true" role="dialog" aria-live="assertive">
    <button class="close-tooltip" aria-label="close dialog"><i class="fa-solid fa-xmark"></i></button>
    <div class="tooltip-content"></div>
  </div>
`;

//Escape should exit the tooltip (really a dialog modal).
tooltip.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeButton.click();
  }
});

document.body.appendChild(tooltip);

const overlay = new Overlay({
  id: 'townTip',
  element: tooltip,
  positioning: 'bottom-center',
  offset: [0, -10]
});
map.addOverlay(overlay);

// Mobile Touch Focus.
document.getElementById('map').addEventListener('touchstart', function () {
  this.focus(); // Force focus on the map container
}, { passive: true });


// Add keyboard panning interaction (default is 128 pixels per key press)
map.addInteraction(new KeyboardPan({
  pixelDelta: 256  // Adjust pan speed (default is 128)
}));

// Close Button Event
const closeButton = tooltip.querySelector('.close-tooltip');
closeButton.addEventListener('click', () => {
  overlay.setPosition(undefined);
  mapElement.focus();
});

// Trap focus inside the modal
document.getElementById("poi-dialog").addEventListener("keydown", function (event) {
  let focusableElements = this.querySelectorAll("button, [href], input, textarea, select");
  let firstElem = focusableElements[0];
  let lastElem = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey && document.activeElement === firstElem) {
      event.preventDefault();
      lastElem.focus();
    } else if (!event.shiftKey && document.activeElement === lastElem) {
      event.preventDefault();
      firstElem.focus();
    }
  }
});

// Handle Click Events to Show Tooltip
map.on('click', function (event) {
  closeButton.click();
  map.forEachFeatureAtPixel(event.pixel, function (feature) {
    const properties = feature.getProperties();
    const coordinates = feature.getGeometry().getCoordinates();
    const point = feature.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="dialog-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
    `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(() => {
  }, 100);
    townLink.focus();
  });
});


/* #region Zoom To Buttons */
// Create the Zoom-To button controls
const zoomToUP = document.getElementById('zoomToUP');
zoomToUP.addEventListener('click', function () {
  closeButton.click();
  map.getView().fit(extent, {duration: 300})
},
  false,
);

/* #region Vector Source Features Load End */
vectorSource.on('featuresloadend', () => {

  // console.log(vectorSource.getFeatures());

  /* #region Set each Feature POI as an object. */
  const dollarville = vectorSource.getFeatureByUid(49);
  const onata = vectorSource.getFeatureByUid(61);
  const tula = vectorSource.getFeatureByUid(65);
  const victoria = vectorSource.getFeatureByUid(67);
  const pequaming = vectorSource.getFeatureByUid(63);
  const centralMine = vectorSource.getFeatureByUid(47);
  const winona = vectorSource.getFeatureByUid(73);
  const labranche = vectorSource.getFeatureByUid(57);
  const watson = vectorSource.getFeatureByUid(71);
  const metropolitan = vectorSource.getFeatureByUid(59);
  const fayette = vectorSource.getFeatureByUid(51);
  const fiborn = vectorSource.getFeatureByUid(53);
  const johnswood = vectorSource.getFeatureByUid(55);
  const atkinsonGibbs = vectorSource.getFeatureByUid(45);
  const walsh = vectorSource.getFeatureByUid(69);
  /* #endregion */

  /* #region Zoom to Dollarville */
  const zoomToDollarville = document.getElementById('zoomToDollarville');
  zoomToDollarville.addEventListener('click', function () {
    closeButton.click();
    const point = dollarville.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = dollarville.getProperties();
    const coordinates = dollarville.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Onata */
  const zoomToOnota = document.getElementById('zoomToOnota');
  zoomToOnota.addEventListener('click', function () {
    closeButton.click();
    const point = onata.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = onata.getProperties();
    const coordinates = onata.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Tula */
  const zoomToTula = document.getElementById('zoomToTula');
  zoomToTula.addEventListener('click', function () {
    closeButton.click();
    const point = tula.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = tula.getProperties();
    const coordinates = tula.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Vicotria */
  const zoomToVicorita = document.getElementById('zoomToVictoria');
  zoomToVictoria.addEventListener('click', function () {
    closeButton.click();
    const point = victoria.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = victoria.getProperties();
    const coordinates = victoria.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Pequaming */
  const zoomToPequaming = document.getElementById('zoomToPequaming');
  zoomToPequaming.addEventListener('click', function () {
    closeButton.click();
    const point = pequaming.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = pequaming.getProperties();
    const coordinates = pequaming.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Central Mine */
  const zoomToCentralMine = document.getElementById('zoomToCentralMine');
  zoomToCentralMine.addEventListener('click', function () {
    closeButton.click();
    const point = centralMine.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = centralMine.getProperties();
    const coordinates = centralMine.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Winona */
  const zoomToWinona = document.getElementById('zoomToWinona');
  zoomToWinona.addEventListener('click', function () {
    closeButton.click();
    const point = winona.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = winona.getProperties();
    const coordinates = winona.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Labranche */
  const zoomToLabranche = document.getElementById('zoomToLabranche');
  zoomToLabranche.addEventListener('click', function () {
    closeButton.click();
    const point = labranche.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = labranche.getProperties();
    const coordinates = labranche.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Watson */
  const zoomToWatson = document.getElementById('zoomToWatson');
  zoomToWatson.addEventListener('click', function () {
    closeButton.click();
    const point = watson.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = watson.getProperties();
    const coordinates = watson.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Metropolitan */
  const zoomToMetropolitan = document.getElementById('zoomToMetropolitan');
  zoomToMetropolitan.addEventListener('click', function () {
    closeButton.click();
    const point = metropolitan.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = metropolitan.getProperties();
    const coordinates = metropolitan.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Fayette */
  const zoomToFayette = document.getElementById('zoomToFayette');
  zoomToFayette.addEventListener('click', function () {
    closeButton.click();
    const point = fayette.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = fayette.getProperties();
    const coordinates = fayette.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Fiborn */
  const zoomToFiborn = document.getElementById('zoomToFiborn');
  zoomToFiborn.addEventListener('click', function () {
    closeButton.click();
    const point = fiborn.getGeometry();
    // console.log(point);
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = fiborn.getProperties();
    const coordinates = fiborn.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Johnswood */
  const zoomToJohnswood = document.getElementById('zoomToJohnswood');
  zoomToJohnswood.addEventListener('click', function () {
    closeButton.click();
    const point = johnswood.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = johnswood.getProperties();
    const coordinates = johnswood.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Atkinson */
  const zoomToAtkinson = document.getElementById('zoomToAtkinson');
  zoomToAtkinson.addEventListener('click', function () {
    closeButton.click();
    const point = atkinsonGibbs.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = atkinsonGibbs.getProperties();
    const coordinates = atkinsonGibbs.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */

  /* #region Zoom to Walsh */
  const zoomToWalsh = document.getElementById('zoomToWalsh');
  zoomToWalsh.addEventListener('click', function () {
    closeButton.click();
    const point = walsh.getGeometry();
    view.fit(point, { padding: [400, 100, 20, 100], minResolution: 100 });
    const properties = walsh.getProperties();
    const coordinates = walsh.getGeometry().getCoordinates();
    const content = tooltip.querySelector('.tooltip-content');
    content.innerHTML = `
      <h1 id="tool-top-header" class="visually-hidden">${properties.name}</h1>
      <img class="tooltip-image" src="${properties.thumbnail}" alt="" aria-hidden="true">
      <a id="townLink" class="a-button" href="${properties.url}" target="_parent">${properties.name} Details</a>
      <a id="googleMapLink" class="a-button" href="${properties.googleMaps}" target="_parent">Google Maps</a>
  `;
    overlay.setPosition(coordinates);
    const townLink = document.getElementById('townLink');
    setTimeout(function () {
      townLink.focus();
    }, 100);
  },
    false,
  );
  /* #endregion */
})
/* #endregion */

/* #endregion */
